export const ObterSegundaDaSemanaAtual = () => {
  const hoje = new Date();
  const diaDaSemana = hoje.getDay();
  const diferenca = diaDaSemana === 0 ? -6 : 1 - diaDaSemana;
  const segunda = new Date(hoje);
  segunda.setDate(hoje.getDate() + diferenca);
  segunda.setHours(0, 0, 0, 0);
  return segunda;
};
